export default {
  'user.login': 'ログイン',
  'user.signup': 'サインイン',
  'user.profile': 'プロファイル',
  'user.reset_password': 'パスワードのリセット',
  'user.user_management': 'ユーザー管理',
  'user.send_verification_sms': '確認のSMSを送信',
  'user.verification_check': '確認チェック',
  'user.change_password': 'パスワードの変更',
  'user.username_email': 'ユーザーネーム／e-mail',
  'user.email': 'e-mail',
  'user.phone': '携帯番号（頭の0は除く）',
  'user.password': 'パスワード',
  'user.forgetpassword': 'パスワードをお忘れですか？',
  'user.loginwithgoogle': 'Googleでログイン',
  'user.createaccount': 'アカウントの作成',
  'user.offerservices': '旅行に関するすべてのサービスを提供します',
  'user.welcome': 'ドンヤロへようこそ',
  'user.firstname': '名',
  'user.lastname': '姓',
  'user.agreemessage': '同意します',
  'user.rotapolicy': '私は Tripsi の規則と規制を読み、同意しました',
  'user.rotapolicy_tripord': 'Tripordのルールに同意します',
  'user.rotacopyright': 'Tripsi Copyright © 2018',
  'user.emptypass': 'パスワードを入力してください（新または旧）',
  'user.oldpass': '旧パスワードが一致しません！',
  'user.employeeadd': '従業員が追加されました！',
  'user.changepass': 'パスワードの変更が完了しました！',
  'user.tryagain': 'やり直してください',
  'user.changepasssuccess': 'パスワードの変更が完了していません',
  'user.newpass': '新しいパスワードを入力してください',
  'user.loginerror': 'ユーザーネームまたはパスワードが間違っています',
  'user.userlock': 'ユーザーネームがロックされました',
  'user.changepasserror':
    '新しいパスワードと確認のための新しいパスワードが違っています',
  'user.tripsi': 'ドンヤロ',
  'user.tripord': 'Tripord',
  'user.userpoint': 'ユーザーのポイント',
  'user.duplicatedusername': 'e-mailがコピーされました',
  'user.signuperror': 'e-mailはユニークでなければなりません',
  'user.avatar': 'アバター',
  'user.forgetyour': '～を忘れましたか？',
  'user.createyour': '～を作成してください',
  'user.account': 'アカウントの作成',
  'user.registerwith': 'または～で登録してください',
  'user.acceptrules': 'このサイトの規約をお守りください',
  'user.fillallfield': 'すべての項目に記入してください',
  'user.favourites': 'お気に入り',
  'user.nograde': 'グレードなし',
  'user.phone': '電話番号',
  'user.has_account': '私はTripsiアカウントを持っています',
  'user.has_account_tripord': 'Tripordアカウントを持っています',
  'user.donthaveaccount': '以前に登録したことはありませんか？',
  'user.signup_free': '無料でお申し込み頂けます',
  'user.pass_recovery': 'パスワードの復元',
  'user.remember_password': 'パスワードを覚えていますか？',
  'authentication.slugone': 'イランで最も信頼できる観光商品のサプライヤー',
  'user.otplogin': 'メッセージ送信規約に同意します',
  'user.otplogintitle': 'ワンタイムパスワード',
  'user.incorrectcode': '入力されたコードが正しくありません',
  'user.untilresend': '再送信するまで',
  'user.phoneoremail': '電子メールまたは携帯電話',
  'user.loginwithusername': 'ユーザー名でログイン',
  'user.sendcode': 'コードを送信する',
  'user.sendagain': '再送信',
};
